import { timeline } from "@/mocks/home";
import SectionHead from "./SectionHead";

const statusMap: Record<string, { label: string; dot: string; chip: string }> = {
  new: { label: "新增料", dot: "bg-accent-400", chip: "bg-accent-500/15 text-accent-300 border-accent-500/30" },
  digging: { label: "深扒中", dot: "bg-primary-400", chip: "bg-primary-500/15 text-primary-300 border-primary-500/30" },
  updating: { label: "复盘更新", dot: "bg-secondary-400", chip: "bg-secondary-500/15 text-secondary-300 border-secondary-500/30" },
};

export default function Timeline() {
  return (
    <section id="live" className="relative bg-background-950 py-20 md:py-28">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHead
          kicker="REAL-TIME"
          title="实时深扒 · 快讯流"
          desc="事件不停，我们的深扒也不停。这里是按时间排列的一手快讯与求证进展，知情人士的每一条线索整理都会即时落到这里。"
          right={
            <a
              href="#cta"
              className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-700 bg-background-900 px-4 py-2.5 text-sm text-foreground-300 transition-colors hover:border-background-500 hover:text-foreground-50"
            >
              <i className="ri-feedback-line text-accent-400"></i>
              提供新线索
            </a>
          }
        />

        <div className="relative mx-auto max-w-3xl">
          <span className="absolute left-[15px] top-2 bottom-2 w-px bg-background-800 md:left-[19px]"></span>

          <ol className="space-y-10">
            {timeline.map((item, idx) => {
              const st = statusMap[item.status] ?? statusMap.updating;
              return (
                <li key={item.id} className="relative flex gap-5 pl-0 md:gap-7">
                  {/* 时间节点 */}
                  <div className="relative z-10 flex w-8 flex-col items-center md:w-10">
                    <span
                      className={`flex h-8 w-8 items-center justify-center rounded-full border border-background-700 bg-background-900 md:h-10 md:w-10 ${
                        idx === 0 ? "ring-2 ring-accent-500/40" : ""
                      }`}
                    >
                      <span className={`h-2.5 w-2.5 rounded-full ${st.dot}`}></span>
                    </span>
                  </div>

                  <div className="flex-1">
                    <div className="mb-3 flex flex-wrap items-center gap-2">
                      <span className="font-heading text-sm font-semibold text-foreground-300">{item.time}</span>
                      <span className={`rounded-full border px-2 py-0.5 text-[11px] ${st.chip}`}>{st.label}</span>
                      <span className="text-xs text-foreground-500">{item.tag}</span>
                    </div>
                    <div className="group cursor-pointer rounded-xl border border-background-800 bg-background-900/80 p-5 transition-colors hover:border-background-600 hover:bg-background-850 md:p-6">
                      <h3 className="font-heading text-base font-bold text-foreground-50 transition-colors group-hover:text-primary-300 md:text-lg">
                        {item.title}
                      </h3>
                      <p className="mt-3 text-sm leading-relaxed text-foreground-400">{item.body}</p>
                      <div className="mt-4 flex flex-wrap items-center gap-4 text-xs text-foreground-500">
                        <span className="flex items-center gap-1.5">
                          <i className="ri-eye-line"></i> {item.id * 2130 + 1800} 围观
                        </span>
                        <span className="flex items-center gap-1.5">
                          <i className="ri-chat-3-line"></i> {item.id * 87 + 120} 讨论
                        </span>
                        <span className="flex items-center gap-1 text-accent-300 group-hover:text-accent-200">
                          <i className="ri-arrow-right-up-line"></i> 展开深扒
                        </span>
                      </div>
                    </div>
                  </div>
                </li>
              );
            })}
          </ol>

          <div className="relative mt-12 flex justify-center">
            <a
              href="#talk"
              className="flex items-center gap-2 whitespace-nowrap rounded-full border border-accent-500/40 bg-accent-500/10 px-5 py-2.5 text-sm font-medium text-accent-300 transition-colors hover:bg-accent-500/20"
            >
              查看更多快讯
              <i className="ri-arrow-down-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}